<ng-container *transloco="let t">
  <p-messages [(value)]="msgs"></p-messages>
  <div
    class="scrollContainer"
    data-scroll-into-view>
    <div
      class="scrollContainer__link"
      id="ctaHeader"
      style="top: -90px"></div>
  </div>
  <div class="buy p-grid p-nogutter p-mt-0 p-jc-center">
    <div class="p-col-12 p-d-flex p-jc-center">
      <div class="p-grid p-mt-0 p-jc-center wrapper">
        <div class="p-col-12 p-xl-9">
          <div class="p-grid p-mt-0 p-jc-center">
            <div class="p-col-12 buy__header p-text-center">
              <h1>
                {{ t('cta.header1') }}<span>{{ t('cta.header2') }}</span>
              </h1>
              <p class="textBlue p-text-bold">{{ t('cta.description1') }}</p>
            </div>
            <div class="p-col-12 buy__description">
              <p>{{ t('cta.description2') }}</p>
              <p class="textBlue p-text-bold">{{ t('cta.description3') }}</p>
            </div>
            <div class="p-col-12 buy__tab p-shadow-9">
              <div
                class="buy__tab__headers p-grid p-nogutter p-text-center p-ai-center">
                <div
                  class="p-col-4 header"
                  [ngClass]="
                    typeOfPolicy === 'invoice' ? 'header--isActive' : 'header'
                  "
                  (click)="selectTypeOfPolicy('invoice')"
                  (mouseleave)="opInvoice.hide()">
                  <p>{{ t('home.tab.header1.videoLong') }}</p>
                  <div
                    class="imgWrapper"
                    #imgWrapper1>
                    <img
                      src="assets/icons/info.svg"
                      class="p-mx-2"
                      alt="info"
                      (mouseover)="opInvoice.show($event)" />
                    <p-overlayPanel
                      #opInvoice
                      [dismissable]="true"
                      [showTransitionOptions]="'200ms'"
                      [appendTo]="imgWrapper1"
                      (mouseleave)="opInvoice.hide()">
                      <ng-template pTemplate>
                        <div>
                          <span class="textGrey"
                            ><span class="p-text-bold">{{
                              t('home.tab.header1.long')
                            }}</span>
                            {{ t('home.tab.header1.content') }}
                          </span>
                        </div>
                        <a
                          routerLink="/"
                          fragment="benefits"
                          >{{ t('home.tab.showMore') }}</a
                        >
                      </ng-template>
                    </p-overlayPanel>
                  </div>
                  <span class="p-text-light p-d-xl-block">{{
                    t('home.tab.header1.short')
                  }}</span>
                </div>
                <div
                  class="p-col-4 header"
                  [ngClass]="
                    typeOfPolicy === 'casco' ? 'header--isActive' : 'header'
                  "
                  (click)="selectTypeOfPolicy('casco')"
                  (mouseleave)="opCasco.hide()">
                  <p>{{ t('home.tab.header2.videoLong') }}</p>
                  <div
                    class="imgWrapper"
                    #imgWrapper2>
                    <img
                      src="assets/icons/info.svg"
                      class="p-mx-2"
                      alt="info"
                      (mouseover)="opCasco.show($event)" />
                    <p-overlayPanel
                      class="centralPanel"
                      #opCasco
                      [dismissable]="true"
                      [showTransitionOptions]="'200ms'"
                      [appendTo]="imgWrapper2"
                      (mouseleave)="opCasco.hide()">
                      <ng-template pTemplate>
                        <div>
                          <span class="textGrey"
                            ><span class="p-text-bold">{{
                              t('home.tab.header2.long')
                            }}</span>
                            {{ t('home.tab.header2.content') }}
                          </span>
                        </div>
                        <a
                          routerLink="/"
                          fragment="benefits"
                          >{{ t('home.tab.showMore') }}</a
                        >
                      </ng-template>
                    </p-overlayPanel>
                  </div>
                  <span class="p-text-light p-d-xl-block">{{
                    t('home.tab.header2.short')
                  }}</span>
                </div>
                <div
                  class="p-col-4 header"
                  [ngClass]="
                    typeOfPolicy === 'direct' ? 'header--isActive' : 'header'
                  "
                  (click)="selectTypeOfPolicy('direct')"
                  (mouseleave)="opDirect.hide()">
                  <p>{{ t('home.tab.header3.videoLong') }}</p>
                  <div
                    class="imgWrapper"
                    #imgWrapper3>
                    <img
                      src="assets/icons/info.svg"
                      class="p-mx-2"
                      alt="info"
                      (mouseover)="opDirect.show($event)" />
                    <p-overlayPanel
                      class="rightSidePanel"
                      #opDirect
                      [dismissable]="true"
                      [showTransitionOptions]="'200ms'"
                      [appendTo]="imgWrapper3"
                      (mouseleave)="opDirect.hide()">
                      <ng-template pTemplate>
                        <div>
                          <span class="textGrey"
                            ><span class="p-text-bold">{{
                              t('home.tab.header3.long')
                            }}</span>
                            {{ t('home.tab.header3.content') }}
                          </span>
                        </div>
                        <a
                          routerLink="/"
                          fragment="benefits"
                          >{{ t('home.tab.showMore') }}</a
                        >
                      </ng-template>
                    </p-overlayPanel>
                  </div>
                </div>
              </div>
              <div class="buy__tab__content p-grid">
                <div class="p-col-12 p-text-center">
                  <p class="textBlue">{{ t('cta.getReady') }}</p>
                </div>
                <div class="p-col-4 itemContainer">
                  <img
                    src="assets/icons/registryNo-icon.svg"
                    alt="registry number icon" />
                  <p class="textBlue p-text-bold">
                    {{ t('documentsUpload.documentBox.registryNo.title') }}
                  </p>
                </div>
                <div
                  class="p-col-4 itemContainer"
                  *ngIf="typeOfPolicy !== 'direct'">
                  <img
                    src="assets/icons/policy-icon.svg"
                    alt="policy icon" />
                  <p class="textBlue p-text-bold">
                    {{ t('documentsUpload.documentBox.policy.title') }}
                  </p>
                </div>
                <div
                  class="p-col-4 itemContainer"
                  *ngIf="typeOfPolicy === 'direct'">
                  <img
                    src="assets/icons/policy-icon.svg"
                    alt="policy icon" />
                  <p class="textBlue p-text-bold">
                    {{ t('documentsUpload.documentBox.policy.titleDirect') }}
                  </p>
                </div>
                <div
                  class="p-col-4 itemContainer"
                  *ngIf="typeOfPolicy === 'invoice'">
                  <img
                    src="assets/icons/invoice-icon.svg"
                    alt="invoice icon" />
                  <p class="textBlue p-text-bold">
                    {{ t('documentsUpload.documentBox.invoice.title') }}
                  </p>
                </div>
              </div>
            </div>

            <div class="p-col-12 p-d-flex p-jc-center p-pt-4">
              <button
                data-cy="engageUserButton"
                class="buttonYellow p-shadow-9"
                fragment="apkHeader"
                (click)="engageUser(true)">
                <span *ngIf="!userEngaged">{{ t('buttons.next') }}</span>
                <p-progressSpinner
                  *ngIf="(isSodanLoading$ | async) && userEngaged"
                  styleClass="button-spinner"
                  strokeWidth="3"
                  animationDuration=".5s" />
              </button>
            </div>

            <div class="p-col-12 p-d-flex p-jc-center">
              <div class="p-grid p-jc-center buy__aboutProcess">
                <div class="p-col-12 buy__aboutProcess__header">
                  <p class="p-text-bold">{{ t('cta.aboutProcess.header') }}</p>
                </div>
                <div class="p-col-12">
                  <div class="p-grid">
                    <div class="p-col-1 stepNumber">
                      <h1 class="textYellow p-text-bold">01</h1>
                      <hr />
                    </div>
                    <div class="p-col-11 p-col-nogutter stepDescription">
                      <p>
                        {{ t('cta.aboutProcess.step1.part1') }}
                        <a
                          data-cy="engageUserButton"
                          (click)="engageUser(true)"
                          fragment="apkHeader"
                          class="textYellow p-text-bold textUnderlined"
                          >{{ t('cta.aboutProcess.step1.part2') }}</a
                        >
                        {{ t('cta.aboutProcess.step1.part3') }}
                      </p>
                    </div>
                    <div class="p-col-1 stepNumber">
                      <h1>02</h1>
                      <hr />
                    </div>
                    <div class="p-col-11 p-col-nogutter stepDescription">
                      <p>{{ t('cta.aboutProcess.step2') }}</p>
                    </div>
                    <div class="p-col-1 stepNumber">
                      <h1>03</h1>
                      <hr />
                    </div>
                    <div class="p-col-11 p-col-nogutter stepDescription">
                      <p>{{ t('cta.aboutProcess.step3') }}</p>
                    </div>
                    <div class="p-col-1 stepNumber">
                      <h1>04</h1>
                      <hr />
                    </div>
                    <div class="p-col-11 p-col-nogutter stepDescription">
                      <p>{{ t('cta.aboutProcess.step4') }}</p>
                    </div>
                    <div class="p-col-1 stepNumber p-jc-start"><h1>05</h1></div>
                    <div class="p-col-11 p-col-nogutter stepDescription">
                      <p>
                        {{ t('cta.aboutProcess.step5.part1') }}
                        <a
                          href="mailto:bok@gaponline.pl"
                          class="textYellow p-text-bold textUnderlined"
                          >{{ t('cta.aboutProcess.step5.part2') }}</a
                        >
                        {{ t('cta.aboutProcess.step5.part3') }}
                      </p>
                    </div>
                    <div class="p-col-12">
                      <p class="textGrey p-text-light">
                        {{ t('cta.aboutProcess.description') }}
                      </p>
                    </div>
                    <div class="p-col-12 p-d-flex p-jc-center p-pb-4">
                      <p class="textGrey p-text-light">
                        <button
                          data-cy="engageUserButton"
                          class="buttonYellow p-shadow-9"
                          (click)="engageUser(true)"
                          fragment="apkHeader">
                          <span *ngIf="!userEngaged">{{
                            t('buttons.next')
                          }}</span>
                          <p-progressSpinner
                            *ngIf="(isSodanLoading$ | async) && userEngaged"
                            styleClass="button-spinner"
                            strokeWidth="3"
                            animationDuration=".5s" />
                        </button>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="p-col-12 p-xl-3 buy__rightColumn">
          <div class="sideTab p-grid p-shadow-9">
            <div class="p-col-12 p-px-4 p-d-md-flex p-jc-md-center">
              <div
                class="p-d-md-flex p-flex-xl-column inputContainer"
                [formGroup]="ctaFormGroup">
                <div class="p-field">
                  <label for="uploadDocPolicyNo">{{
                    t('cta.sideTab.1.label')
                  }}</label>
                  <p-inputMask
                    id="uploadDocPolicyNo"
                    formControlName="uploadDocPolicyNo"
                    mask="aaaaaa-99999999"
                    slotChar=""
                    [autoClear]="true"
                    (click)="
                      this.ctaFormGroup.controls.uploadDocPolicyNo.reset()
                    "
                    placeholder="{{
                      t('cta.sideTab.1.placeholder')
                    }}"></p-inputMask>
                  <button
                    class="buttonYellow"
                    (click)="handleDocumentsUpload()"
                    [disabled]="
                      ctaFormGroup.get('uploadDocPolicyNo').value === null
                    ">
                    {{ t('cta.sideTab.1.button') }}
                  </button>
                </div>

                <div class="p-field">
                  <label for="policyNoForCalculation">{{
                    t('cta.sideTab.3.label')
                  }}</label>
                  <p-inputMask
                    id="policyNoForCalculation"
                    formControlName="readCalculationPolicyNo"
                    mask="aaaa-999999"
                    slotChar=""
                    [autoClear]="true"
                    (click)="
                      this.ctaFormGroup.controls.readCalculationPolicyNo.reset()
                    "
                    placeholder="{{
                      t('cta.sideTab.3.placeholder')
                    }}"></p-inputMask>
                  <button
                    class="buttonYellow"
                    (click)="handlePolicyRead()"
                    [disabled]="
                      ctaFormGroup.get('readCalculationPolicyNo').value === null
                    ">
                    {{ t('cta.sideTab.3.button') }}
                  </button>
                </div>

                <div class="p-field">
                  <label for="smsPolicyNo">{{
                    t('cta.sideTab.2.label')
                  }}</label>
                  <p-inputMask
                    class="smsPolicyNo"
                    id="smsPolicyNo"
                    formControlName="policyNo"
                    mask="aaaaaa-99999999"
                    slotChar=""
                    [autoClear]="true"
                    (click)="this.ctaFormGroup.controls.policyNo.reset()"
                    placeholder="{{
                      t('cta.sideTab.1.placeholder')
                    }}"></p-inputMask>

                  <p-inputMask
                    id="smsCode"
                    mask="999999"
                    slotChar=""
                    placeholder="{{ t('cta.sideTab.2.placeholder') }}"
                    formControlName="smsCode"
                    [autoClear]="true"
                    (click)="
                      this.ctaFormGroup.controls.smsCode.reset()
                    "></p-inputMask>
                  <button
                    class="buttonYellow"
                    [disabled]="ctaFormGroup.invalid || signing"
                    (click)="handleSignPolicy()">
                    {{ t('cta.sideTab.2.button') }}
                  </button>
                </div>
              </div>
            </div>

            <div
              class="p-col-12 p-pt-4 p-d-flex p-flex-wrap p-flex-md-nowrap p-flex-xl-column p-ai-xl-center p-jc-around">
              <div class="imgContainer">
                <img
                  src="assets/icons/stepps/step1.svg"
                  alt="" />
                <p>
                  {{ t('cta.aboutProcess.iconLabel.1') }}
                </p>
              </div>
              <div class="imgContainer">
                <img
                  src="assets/icons/stepps/step2.svg"
                  alt="" />
                <p>
                  {{ t('cta.aboutProcess.iconLabel.2') }}
                </p>
              </div>
              <div class="imgContainer">
                <img
                  src="assets/icons/stepps/step3.svg"
                  alt="" />
                <p>
                  {{ t('cta.aboutProcess.iconLabel.3') }}
                </p>
              </div>
              <div class="imgContainer">
                <img
                  src="assets/icons/stepps/step4.svg"
                  alt="" />
                <p>
                  {{ t('cta.aboutProcess.iconLabel.4') }}
                </p>
              </div>
              <div class="imgContainer">
                <img
                  src="assets/icons/stepps/step5.svg"
                  alt="" />
                <p>
                  {{ t('cta.aboutProcess.iconLabel.5') }}
                </p>
              </div>
              <div class="imgContainer">
                <img
                  src="assets/icons/stepps/step6.svg"
                  alt="" />
                <p>
                  {{ t('cta.aboutProcess.iconLabel.6') }}
                </p>
              </div>
              <div class="imgContainer">
                <img
                  src="assets/icons/stepps/step7.svg"
                  alt="" />
                <p>
                  {{ t('cta.aboutProcess.iconLabel.7') }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
